import React from 'react';
import { OrderLogType } from '../../../enums/OrderLogType';
import { FormatHelper } from '../../../helpers/FormatHelper';
import { OrderLog } from '../../../models/OrderLog';
import { MultilinePopover } from '../../../common-components/MultilinePopover/MultilinePopover';

export interface IAssemblerQuantityPopoverProps {
  orderItemId: number;
  orderItemSku?: string;
  orderItemName: string;
  quantity?: number;
  orderLogType: OrderLogType;
  assemblyHistory?: OrderLog[];
}

export const AssemblerQuantityPopover: React.FC<IAssemblerQuantityPopoverProps> = ({
  orderItemId,
  orderItemSku,
  orderItemName,
  quantity,
  orderLogType,
  assemblyHistory
}) => {

  if (!quantity) return <>0</>;

  const lines = assemblyHistory?.filter(orderLog =>
    orderLog.orderLogType === orderLogType && orderLog.details.includes(`| Item: ${orderItemSku} - ${orderItemName}`)
  )?.map(orderLog => {
    return `${orderLog.doneBy?.name} ${FormatHelper.formatDateTime(orderLog.createdAt)}`;
  }) || [];

  if (lines.length > 0) {
    return (
      <MultilinePopover
        keyid={`received-item-${orderItemId}`}
        bagdeValue={`${quantity}`}
        marginLeft='0px'
        bagdeBackgroundColor='#bbb'
        bagdeTextColor='#fff'
        lines={lines}
      />
    );
  }

  return (
    <>{quantity}</>
  );

}